import { FilterPaidEventOrganizerDto } from '@smatchy/sdk';
import type {
  APaidEventInDetail,
  APaidEventTheWalletLists,
} from '../../../events/domains/the-paid-event-the-wallet-shows';
export interface EarningKpis {
  escrow: number;
  available: number;
  transferred: number;
}
export interface EarningResponse {
  data: {
    events: APaidEventTheWalletLists[];
    date: string;
  }[];
  total: number;
  page: number;
  limit: number;
}
export class SetLoadingKpisEarningsAction {
  static readonly type = '[Event] Set loading kpis earnings event';
}

export class SetLoadingFilterEarningsAction {
  static readonly type = '[Event] Set loading filter earnings event';
  constructor(public loading: boolean) {}
}

export class LoadKpisEarningAction {
  static readonly type = '[Event] Load kpis earnings event';
  constructor(public kpis: EarningKpis) {}
}

export class FilterEarningAction {
  static readonly type = '[Event] Filter earnings event';
  constructor(public filter: FilterPaidEventOrganizerDto) {}
}
export class FilterEarningSuccessAction {
  static readonly type = '[Event] Filter earnings event success';
  constructor(public response: EarningResponse) {}
}
export class FilterEarningDetailAction {
  static readonly type = '[Event] Filter earnings event detail';
  constructor(public id: string) {}
}
export class FilterEarningDetailSuccessAction {
  static readonly type = '[Event] Filter earnings event detail success';
  constructor(
    public response: {
      event: APaidEventInDetail;
    },
  ) {}
}

export class ResetFilterEarningsAction {
  static readonly type = '[FilterEvents] ResetFilterEventsAction';
}

export class AddSportSelectedToFilterEarningsAction {
  static readonly type = '[FilterEvents] AddSportSelectedToFilterEarningsAction';

  constructor(public sportId: string, public resetOther: boolean) {}
}
export class AddDateFilterToFilterEarningsAction {
  static readonly type = '[FilterEvents] AddDateFilterToFilterEarningsAction';

  constructor(public dateFilter: string, public fromDate?: string, public toDate?: string) {}
}

export class RemoveSportSelectedToFilterEarningsAction {
  static readonly type = '[FilterEvents] RemoveSportSelectedToFilterEarningsAction';

  constructor(public sportId: string) {}
}
export class RemoveDateFilterToFilterEarningsAction {
  static readonly type = '[FilterEvents] RemoveDateFilterToFilterEarningsAction';
}
export class AddStatusToFilterEarningsAction {
  static readonly type = '[FilterEvents] AddStatusToFilterEarningsAction';

  constructor(public payoutStatus: string) {}
}

export class RemoveStatusToFilterEarningsAction {
  static readonly type = '[FilterEvents] RemoveStatusToFilterEarningsAction';
  constructor(public payoutStatus: string) {}
}
export class AddPriceToFilterEarningsAction {
  static readonly type = '[FilterEvents] AddPriceToFilterEarningsAction';

  constructor(public priceFrom: number, public priceTo: number) {}
}

export class RemovePriceToFilterEarningsAction {
  static readonly type = '[FilterEvents] RemovePriceToFilterEarningsAction';
}
